import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';
import { LinkButton } from '../../../../../common/LinkButton';
import { handleScrollToPhotosClick } from './handleScrollToPhotosClick';

export const NoPhotos = () => (
  <>
    <InlineText2 color="superblack_100">В Топе можно размещать только объявления с фото</InlineText2>

    <LinkButton marginTop={8} onClick={handleScrollToPhotosClick}>
      Добавить фото
    </LinkButton>
  </>
);
